import { Route } from "react-router-dom";
import { _adr } from "../address";
import { Roles } from "../tools/services";
import { ProtectedRoute } from "../tools/protectedRoute";
import DCCharge from "../components/dcPurchase/shop/charge/dcCharge";
import DCPrefactor from "../components/dcPurchase/shop/prefactor/dcPrefactor";
import DCFinal from "../components/dcPurchase/shop/final/dcFinal";
import DCReport from "../components/dcPurchase/report/report-list/dc-report";

export const dcPurchaseRoutes = [
	<Route
		key="dc-charge"
		path={_adr.Root + _adr.DCPurchase.Index + _adr.DCPurchase.Shop + _adr.DCPurchase.Charge}
		element={<ProtectedRoute role={Roles.Dealer_DCPurchase_B2C} element={DCCharge} />}
	/>,
	<Route
		key="dc-prefactor"
		path={_adr.Root + _adr.DCPurchase.Index + _adr.DCPurchase.Shop + _adr.DCPurchase.Prefactor}
		element={<ProtectedRoute role={Roles.Dealer_DCPurchase_B2C} element={DCPrefactor} />}
	/>,
	<Route
		key="dc-final"
		path={_adr.Root + _adr.DCPurchase.Index + _adr.DCPurchase.Shop + _adr.DCPurchase.Final}
		element={<ProtectedRoute role={Roles.Dealer_DCPurchase_B2C} element={DCFinal} />}
	/>,
	<Route
		key="dc-report"
		path={_adr.Root + _adr.DCPurchase.Index + _adr.DCPurchase.Report.Index + _adr.DCPurchase.Report.List}
		element={<ProtectedRoute role={Roles.Dealer_DCPurchase_ReportOne} element={DCReport} />}
	/>,
];
